import { render, staticRenderFns } from "./MyOrdersOnControl.vue?vue&type=template&id=66c7d17e"
import script from "./MyOrdersOnControl.vue?vue&type=script&lang=js"
export * from "./MyOrdersOnControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports